import _ from 'lodash';

const authorization = (() => {
    const _authorizations = {};

    const authy = (authorizations) => {
        _.forEach(authorizations, auth => {
            _authorizations[auth.toLowerCase()] = true;
        });
    };

    authy.isAuthorized = (permission, feature) => {
        return  _authorizations[permission];
    };

    return authy;
})();

export default authorization;



// WEBPACK FOOTER //
// ./src/scripts/api/authorization.js